module.exports = __webpack_public_path__ + "img/tutorial-f03-06.d78e6a48.png";